import { inject } from '@angular/core';
import { environment } from '@environment';
import { Actions, createEffect, ofType, ROOT_EFFECTS_INIT } from '@ngrx/effects';
import { loadServicesSuccess } from '@stores/services/services.action';
import { AccountWebservice } from '@wizbii-utils/angular/webservices';
import { map, switchMap } from 'rxjs';

export const initServices = createEffect(
  (actions$ = inject(Actions), accountWebservice = inject(AccountWebservice)) =>
    actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => accountWebservice.getServicesByCountry(environment.i18n.locale, undefined, 'v2')),
      map((country) => {
        const service = country.services.find((service) => service.id === environment.applicationId);
        return service
          ? {
              ...service,
              supportEmails: country.supportEmails,
            }
          : undefined;
      }),
      map((service) => loadServicesSuccess({ service }))
    ),
  { functional: true }
);
